const MOVE_SOUND_PATH = "/sounds/chess-move.mp3";
const CAPTURE_SOUND_PATH = "/sounds/chess-capture.mp3";

let moveSound: HTMLAudioElement | null = null;
let captureSound: HTMLAudioElement | null = null;

/**
 * Plays a real recorded chess-piece sample for board navigation. The samples
 * are CC0 and their source is retained in public/sounds/LICENSE.txt.
 */
export const playChessMoveSound = (san?: string) => {
  if (typeof window === "undefined") return;

  const isCapture = san?.includes("x") ?? false;
  let sound = isCapture ? captureSound : moveSound;
  if (!sound) {
    sound = new Audio(isCapture ? CAPTURE_SOUND_PATH : MOVE_SOUND_PATH);
    sound.preload = "auto";
    sound.volume = 0.38;
    if (isCapture) captureSound = sound;
    else moveSound = sound;
  }

  sound.currentTime = 0;
  void sound.play().catch((error: unknown) => {
    console.warn("Could not play chessboard sound.", error);
  });
};
